export default __webpack_public_path__ + "static/media/07.8a76e16b.svg";